import { selectCurrentUser } from 'state/selectors';
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector';

export const useGetCurrentUser = () => useShallowEqualSelector(selectCurrentUser);
